import { Box, InlineStack, TextLabel } from '@customerio/pluma-components/react';
import type { UpdateOptions } from '../use-tab-search';
import { DEFAULT_BROADCASTS_SORT, type ApiTriggeredSearch } from '../url-state';
import { CatalogFilters, CatalogTopicFilter } from './catalog-filters';
import { SortControl, type SortOption } from './list-filters/sort-control';

type ApiTriggeredSort = 'sent' | 'name' | 'created' | 'updated';

const SORT_OPTIONS: ReadonlyArray<SortOption<ApiTriggeredSort>> = [
  { label: 'Sent emails', value: 'sent' },
  { label: 'Name', value: 'name' },
  { label: 'Created', value: 'created' },
  { label: 'Edited', value: 'updated' },
];

type ApiTriggeredFiltersProps = {
  search: ApiTriggeredSearch;
  onChange: (patch: Partial<ApiTriggeredSearch>, options: UpdateOptions) => void;
};

/**
 * The API-triggered tab's filters: tags, goals and object types, the topic, and the sort. The
 * goal, object type and topic pickers only appear when there is something to pick from.
 */
export function ApiTriggeredFilters({ search, onChange }: ApiTriggeredFiltersProps) {
  return (
    <InlineStack alignBlock="center" gap="100">
      <InlineStack alignBlock="center" gap="100">
        <TextLabel>Filter by</TextLabel>
        <CatalogFilters search={search} onChange={onChange} />
      </InlineStack>
      <CatalogTopicFilter search={search} onChange={onChange} />
      <Box flex={1} maxW="full" minW="0" />
      <SortControl
        options={SORT_OPTIONS}
        selected={search.sort ?? DEFAULT_BROADCASTS_SORT}
        isDescending={!(search.asc ?? false)}
        onChange={(value) => onChange({ sort: value }, { replace: false })}
        onDirectionChange={(isDescending) => onChange({ asc: !isDescending }, { replace: false })}
      />
    </InlineStack>
  );
}
